import {
    makeHttpRequest,
    mapDatabaseParamsFromServer,
    mapPaginationParamsToServer,
} from "@/shared";

import { mapSourcesAttractionFromServer } from "./mappers/mapSourcesAttractionFromServer";

export const getSourcesAttraction = async (paginationParams = {}) => {
    const response = (
        await makeHttpRequest({
            url: "/attraction",
            method: "GET",
            params: mapPaginationParamsToServer(paginationParams),
        })
    ).data;

    return {
        data: mapSourcesAttractionFromServer(response.data),
        ...mapDatabaseParamsFromServer(response),
    };
};
